import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ConfirmationService } from 'primeng/api';
import { environment } from '../environments/environment';
import { MessageModule, MessageService, MessagesModule, ToastModule } from 'primeng';
import { AppRoutingModule } from './app-routing.module';
import { MiniProfilerInterceptor } from './classes/mini-profiler-interceptor';
import { AccountComponent } from './components/account/account.component';
import { AppRootComponent } from './components/app-root/app-root.component';
import { AppMenuComponent } from './components/app/app-menu.component';
import { AppSubMenu } from './components/app/app-sub-menu.component';
import { AppTopBarComponent } from './components/app/app-topbar.component';
import { AppComponent } from './components/app/app.component';
//import { IdleBannerComponent } from './components/banner/idle-banner.component';
import { NotificationBannerComponent } from './components/banner/notification-banner.component';
import { AppendDateTimeInterceptor } from './interceptors/append-datetime.interceptor';
import { EmptyResponseBodyInterceptor } from './interceptors/empty-response-body.interceptor';
//import { OrgInactiveInterceptor } from './interceptors/org-inactive.interceptor';
import { VmeCommonModule } from './vme-common.module';
import { PostcodePipe } from './pipes/postcode.pipe';
import { CustomRouteReuseStrategy } from './utils/CustomRouteReuseStrategy';
import { RouteReuseStrategy } from '@angular/router';
import { NgxJsonViewerModule } from './modules/ngx-json-viewer/ngx-json-viewer.module';
import { TelephonyComponentsModule } from './telephony-components.module';

import {
  RECAPTCHA_SETTINGS,
  RecaptchaComponent,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { QuillModule } from 'ngx-quill';
import { DecimalPipe } from '@angular/common';
import { BroadcastHubEventService } from './services/broadcast-hub-event.service';
import { BroadcastHubService } from './services/broadcast-hub.service';
import { WidgetComponent } from './components/widget/widget.component';
import { B2cComponent } from './components/b2c/b2c.component';
import { JwtAuthInterceptor } from './interceptors/jwt-auth.interceptor';
import { NgxStripeModule } from 'ngx-stripe';

import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import { AccountSuspendedComponent } from './components/dashboard/account-suspended/account-suspended.component';
import { BankersRoundPipe } from './pipes/bankers-round.pipe';
import { JsonPatchInterceptor } from './interceptors/json-patch-interceptor'; // a plugin!

const mapsAPIKey =
  environment && environment.maps && environment.maps.apikey ? environment.maps.apikey : '';

const stripePublishableKey =
  environment && environment.stripe && environment.stripe.publishableKey
    ? environment.stripe.publishableKey
    : '';

FullCalendarModule.registerPlugins([dayGridPlugin, interactionPlugin]);

@NgModule({
  declarations: [
    AccountComponent,
    AppComponent,
    AppMenuComponent,
    AppRootComponent,
    AppSubMenu,
    AppTopBarComponent,
    //    IdleBannerComponent,
    NotificationBannerComponent,
    WidgetComponent,
    B2cComponent,
    AccountSuspendedComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    VmeCommonModule,
    TelephonyComponentsModule,
    NgxJsonViewerModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MessageModule,
    MessagesModule,
    RecaptchaFormsModule,
    FullCalendarModule,
    QuillModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: mapsAPIKey,
      libraries: ['places', 'geometry', 'visualization'],
    }),
    ToastModule,
    NgxStripeModule.forRoot(stripePublishableKey),
    //DriverExperienceModule
  ],
  providers: [
    // todo: check out Multiple App Initializers, make sure they both work
    ConfirmationService,
    MessageService,
    PostcodePipe,
    DecimalPipe,
    BroadcastHubService,
    BroadcastHubEventService,
    Title,
    GoogleMapsAPIWrapper,
    RecaptchaComponent,
    // todo: reinstantiate in the right place
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (service: CurrentUserWatchService) => () => service.watch(),
    //   deps: [CurrentUserWatchService],
    //   multi: true,
    // },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AppendDateTimeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EmptyResponseBodyInterceptor, multi: true },
    //    { provide: HTTP_INTERCEPTORS, useClass: OrgInactiveInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JsonPatchInterceptor, multi: true },
    // todo: investigate what we need to do to make this work again
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MiniProfilerInterceptor,
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptcha.siteKey } as RecaptchaSettings,
    },
  ],
  bootstrap: [AppRootComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
